import React, { useContext, useState, useEffect } from "react";
import { RegisterContainer } from "../components/Register.styled";
import WizardForm from "../../../components/form/wizard";
import PersonalInformation from "./steps/PersonalInformation";
import PersonalAddress from "./steps/PersonalAddress";
import OTPVerification from "./steps/OTPVerification";
import UploadImage from "./steps/UploadImage";
import IDCard from "./steps/IDCard";
import { NewCitizenContext } from "./NewCitizenContext";
import Summary from "./steps/Summary";
import { RegistrationHeader } from "../components/registrationHeader";
import { CitizenDetailHeader } from "pages/SocialService/components/citizenDetailHeader";
import styled, { css } from "styled-components";
import { desktop, minTablet } from "utils/styles";
import { ENTITIES, entity } from "constant/entity";

const headerStyle = css`
  ${desktop`
    * {
      display: none !important;
    }
    display: none !important;
    > img {
      display: none !important;
    }
  `}
`;
const akapBigasStyles =
  entity === ENTITIES.AKAP_BIGAS
    ? minTablet`
        display: none !important;
      `
    : "";
const StyledCitizenDetailHeader = styled(CitizenDetailHeader)`
  ${headerStyle}
  ${akapBigasStyles}
`;
const StyledRegistrationHeader = styled(RegistrationHeader)`
  ${headerStyle}
  ${akapBigasStyles}
`;

const NewCitizensComponent = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const {
    checkUserExist,
    sendOTPMobile,
    verifyOTP,
    verifyPhoto,
    conditionalRegisterValidator,
    state,
    stateDispatchMain,
  } = useContext(NewCitizenContext);

  const isIdCardStep = currentStep === 5;

  useEffect(() => {
    if (state.shouldGoToSummary) {
      setCurrentStep(4); // Summary step
      stateDispatchMain({ key: "shouldGoToSummary", payload: false });
    } else if (state.resetWizard) {
      setCurrentStep(0); // First step
      stateDispatchMain({ key: "resetWizard", payload: false });
    }
  }, [state.shouldGoToSummary, state.resetWizard, stateDispatchMain]);

  // Create stable steps array with dynamic first step
  const steps = [
    {
      title: "Personal Information",
      component: PersonalInformation,
      hideBackBtn: true,
      asyncValidator: checkUserExist,
    },
    {
      title: "Address",
      component: PersonalAddress,
      asyncFn: sendOTPMobile,
    },
    {
      title: "Verification",
      centerTitle: true,
      component: OTPVerification,
      hideBackBtn: true,
      btnNextOverwriteTitle: "Ipadala",
      asyncValidator: verifyOTP,
    },
    {
      title: "Upload Image",
      centerTitle: true,
      component: UploadImage,
      hideBackBtn: true,
      btnNextOverwriteTitle: "Ipadala",
      asyncValidator: verifyPhoto,
    },
    {
      title: "Summary",
      hideTitle: true,
      component: Summary,
      hideBackBtn: true,
      btnNextOverwriteTitle: "Ipadala",
      asyncValidator: conditionalRegisterValidator,
    },
    {
      title: "Download ID Card",
      centerTitle: true,
      component: IDCard,
      hideBackBtn: true,
      hideWizardSteps: true,
      hideNextBtn: true,
    },
  ];

  return (
    <RegisterContainer>
      {isIdCardStep ? <StyledCitizenDetailHeader /> : <StyledRegistrationHeader />}
      <WizardForm
        isIdCardStep={isIdCardStep}
        steps={steps}
        setCurrentStep={setCurrentStep}
        currentStepFromProps={currentStep}
        isHidden={state.isHidden}
        resetFormData={state.resetWizard}
      />
    </RegisterContainer>
  );
};

export default NewCitizensComponent;
